import { render } from "./Faqs.vue?vue&type=template&id=00af0cb2&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"

import "./Faqs.vue?vue&type=style&index=0&id=00af0cb2&lang=scss"
import "./Faqs.vue?vue&type=style&index=1&id=00af0cb2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2492902713/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00af0cb2"]])

export default __exports__